import { default as Base } from './base';
import { default as Generic } from './generic';

export default {
  Base,
  Generic,
};
